<script>
import LogoIcon5 from '@/assets/icons/rocket-icon.png';
import Typography from '@/components/v3/base/Typography';

export default {
  name: 'ProjectInProcessing',
  components: {
    Typography,
  },

  data() {
    return {
      LogoIcon5,
    };
  },
};
</script>
<template>
  <div class="tw-w-full tw-py-20 tw-flex tw-justify-center tw-items-center">
    <div>
      <div class="tw-text-center">
        <div><img :src="LogoIcon5" class="tw-inline tw-w-[170px]" /></div>
        <Typography variant="headline-5" class="tw-mt-6">
          Processing your job submission...
        </Typography>
        <Typography variant="body-1" class="tw-mt-4 tw-w-[400px]">
          Your project will be ready within 48 hours. You’ll receive an email
          inviting you back to review interested candidates. Stay tuned!
        </Typography>
      </div>
    </div>
  </div>
</template>
